import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import PrimaryButton from '../ui/PrimaryButton';

const { FiUser, FiDollarSign } = FiIcons;

const termOptions = [
  { months: 12, label: '12 mo', note: 'Least interest' },
  { months: 24, label: '24 mo', note: 'Balanced' },
  { months: 36, label: '36 mo', note: 'Lowest monthly' },
];

export default function Step2cLoanInfo({ onSubmit, amount }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dob, setDob] = useState('');
  const [income, setIncome] = useState('');
  const [term, setTerm] = useState(24);
  const monthly = (amount / term).toFixed(2);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ firstName, lastName, dob, income, term });
  };

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="card-premium">
      <div className="text-center mb-8">
        <div className="w-14 h-14 bg-blue-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <SafeIcon icon={FiUser} className="w-7 h-7 text-blue-600" />
        </div>
        <h2 className="text-3xl font-bold text-slate-900 mb-2">Your Loan Application</h2>
        <p className="text-slate-600">We'll check offers from our lending partners. No hard pull yet.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">First Name</label>
            <input required type="text" placeholder="Jane" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="input-premium" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Last Name</label>
            <input required type="text" placeholder="Doe" value={lastName} onChange={(e) => setLastName(e.target.value)} className="input-premium" />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Date of Birth</label>
          <input required type="date" value={dob} onChange={(e) => setDob(e.target.value)} className="input-premium" />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">Annual Income (approx.)</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
              <SafeIcon icon={FiDollarSign} className="h-5 w-5 text-slate-400" />
            </div>
            <input required type="number" min="0" placeholder="45000" value={income} onChange={(e) => setIncome(e.target.value)} className="input-premium pl-14" />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-3">Preferred Repayment Term</label>
          <div className="grid grid-cols-3 gap-3">
            {termOptions.map((opt) => (
              <button
                key={opt.months}
                type="button"
                onClick={() => setTerm(opt.months)}
                style={{
                  background: term === opt.months ? 'linear-gradient(135deg, #eff6ff, #eef2ff)' : '#f8fafc',
                  border: term === opt.months ? '2px solid #2563eb' : '2px solid #e2e8f0',
                  borderRadius: '14px',
                  padding: '16px 8px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  boxShadow: term === opt.months ? '0 2px 8px rgba(37,99,235,0.15)' : 'none',
                }}
              >
                <div style={{ fontWeight: 700, fontSize: '15px', color: term === opt.months ? '#1d4ed8' : '#1e293b' }}>{opt.label}</div>
                <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>{opt.note}</div>
              </button>
            ))}
          </div>

          <div className="mt-4 bg-slate-50 rounded-2xl p-5 border border-slate-100 text-center">
            <p className="text-sm text-slate-500">Estimated monthly payment</p>
            <p className="text-3xl font-extrabold text-slate-900 mt-1">
              ~${monthly}<span className="text-base font-normal text-slate-500">/mo</span>
            </p>
            <p className="text-xs text-slate-400 mt-1">Actual rate set by lender.</p>
          </div>
        </div>

        <PrimaryButton type="submit" className="w-full py-4 text-lg">
          Check My Offers
        </PrimaryButton>
      </form>
    </motion.div>
  );
}